import PropTypes from "prop-types";
import React, { Fragment, useEffect, useState } from "react";
import bannerData from "../../data/banner/banner-one.json";
import BannerOneSingle from "../../components/banner/BannerOneSingle.js";
import Swiper, { SwiperSlide } from "../../components/swiper";
import { EffectFade, Thumbs } from 'swiper';

const BannerOne = ({ block }) => {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const gallerySwiperParams = {
    spaceBetween: 10,
    loop: true,
    effect: "fade",
    fadeEffect: {
      crossFade: true
    },
    thumbs: { swiper: thumbsSwiper },
    modules: [EffectFade, Thumbs],
  };
  const thumbnailSwiperParams = {
    onSwiper: setThumbsSwiper,
    spaceBetween: 10,
    slidesPerView: 4,
    touchRatio: 0.2,
    freeMode: true,
    loop: false,
    //slideToClickedSlide: true,
    //navigation: true
  };
  return (
    <div
      className={`banner-area ${block.spaceTopClass ? block.spaceTopClass : ""} ${
        block.spaceBottomClass ? block.spaceBottomClass : ""
      }`}
    >
      <div className="container">
        <div className="row">
        <Swiper options={gallerySwiperParams}>
          {bannerData &&
            bannerData.map((single, key) => {
              return (
                <SwiperSlide key={key}>
                <BannerOneSingle
                  data={single}
                  key={key}
                  spaceBottomClass="mb-30"
                />
                </SwiperSlide>
              );
            })}
            </Swiper>
        </div>
      </div>
    </div>
  );
};

BannerOne.propTypes = {
  spaceBottomClass: PropTypes.string,
  spaceTopClass: PropTypes.string
};

export default BannerOne;
